"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.oriPackageJsonSchema = void 0;
var z = _interopRequireWildcard(require("zod"));
var _OriTeam = require("./OriTeam");
var _PackageJson = require("./PackageJson");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const coverageThresholdPropsSchema = z.object({
  branches: z.number().optional(),
  functions: z.number().optional(),
  lines: z.number().optional(),
  statements: z.number().optional()
});
const coverageThresholdSchema = z.object({
  global: coverageThresholdPropsSchema.strict().optional()
}).optional();
const jestConfigSchema = z.object({
  coverageThreshold: coverageThresholdSchema
}).optional();
const oriPackageJsonSchema = exports.oriPackageJsonSchema = _PackageJson.packageJsonSchema.extend({
  source: z.string().optional(),
  jest: jestConfigSchema,
  'jest-junit': z.record(z.unknown()).optional(),
  lumos: z.object({}).optional(),
  teamName: _OriTeam.oriTeamSchema.optional(),
  packageManager: z.string().optional(),
  msw: z.object({
    workerDirectory: z.string()
  }).optional()
});
